import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  container: {
    margin: '20px auto',
    padding: '0 20px'
  },
  loader: {
    justifyContent: 'center',
    display: 'flex',
    paddingTop: '24px'
  }
}));
